/** @typedef {import('../types/entity/LegIndexData').LegIndexData} LegIndexData */

/**
 *
 * @param {LegIndexData} a
 * @param {LegIndexData} b
 */
export const compareLegIndexData = (a, b) => {
    const areEqual =
        a.metricsStartIdx === b.metricsStartIdx &&
        a.timestamp === b.timestamp &&
        a.activityId === b.activityId &&
        a.typeKey === b.typeKey &&
        a.typeId === b.typeId &&
        a.polylineStartIdx === b.polylineStartIdx;
    return areEqual;
};
